import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-538d6245"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  class: "DialogSection FlexColumn",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_7 = {
  class: "CookiesRow W-75",
  style: {"margin-top":"4em","font-size":"1.1em"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "SettingsName" }
const _hoisted_10 = { class: "CookiesRow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_12 = { class: "SettingsName" }
const _hoisted_13 = { class: "CookiesRow" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_15 = { class: "DialogSectionTitle" }
const _hoisted_16 = { class: "DialogSection" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_19 = {
  key: 1,
  class: "CookiesDialogFooter"
}
const _hoisted_20 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesDateInput = _resolveComponent("CookiesDateInput")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access(_ctx.DialogData.Editing ? 'Companies_Edit': 'Companies_Create'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 'CookiesDialog_' + _ctx.DialogIndex,
          class: "CookiesDialogdBody"
        }, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_CookiesDescriptionBox, {
                      style: {"width":"20em","max-width":"50vw"},
                      LimitLines: 2,
                      CustomStyle: 'max-height: 2.5em; min-height: 2.5em; overflow:hidden; resize: none;',
                      Placeholder: _ctx.Translate('Company Name'),
                      CookiesInvalidInput: !_ctx.MEMRead('D_Company_Name') && _ctx.MEMRead('D_Company_Name') === '',
                      ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Company_Name') && _ctx.MEMRead('D_Company_Name') === ''),
                      Res: 'D_Company_Name',
                      Default: ''
                    }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
                    _createVNode(_component_CookiesNormalInput, {
                      Placeholder: _ctx.Translate('Legal Name'),
                      Res: 'D_Company_LegalName',
                      Default: ''
                    }, null, 8, ["Placeholder"]),
                    _createVNode(_component_CookiesDescriptionBox, {
                      Placeholder: _ctx.Translate('Description'),
                      Res: 'D_Company_Description',
                      Default: ''
                    }, null, 8, ["Placeholder"]),
                    _createVNode(_component_CookiesNormalInput, {
                      Placeholder: _ctx.Translate('CompanyNO'),
                      Res: 'D_Company_CompanyNO',
                      Default: ''
                    }, null, 8, ["Placeholder"]),
                    _createVNode(_component_CookiesNormalInput, {
                      Placeholder: _ctx.Translate('City'),
                      Res: 'D_Company_City',
                      Default: ''
                    }, null, 8, ["Placeholder"]),
                    _createVNode(_component_CookiesNormalInput, {
                      Placeholder: _ctx.Translate('Province'),
                      Res: 'D_Company_Province',
                      Default: ''
                    }, null, 8, ["Placeholder"]),
                    _createVNode(_component_CookiesNormalInput, {
                      Placeholder: _ctx.Translate('Street'),
                      Res: 'D_Company_Street',
                      Default: ''
                    }, null, 8, ["Placeholder"]),
                    _createVNode(_component_CookiesNumberInput, {
                      Step: 0.1,
                      Name: _ctx.Translate('Tax Ratio'),
                      Unit: '%',
                      Res: 'D_Company_TaxRatio',
                      Default: 0
                    }, null, 8, ["Name"]),
                    _createVNode(_component_CookiesNumberInput, {
                      Step: 5,
                      Name: _ctx.Translate('Currency'),
                      Unit: _ctx.PriceUnit,
                      Res: 'D_Company_Currency',
                      Default: 0
                    }, null, 8, ["Name", "Unit"]),
                    _createVNode(_component_CookiesDateInput, {
                      class: "M-Auto",
                      Name: _ctx.Translate('Founding Date'),
                      Type: 'date',
                      Res: 'D_Company_FoundingDate'
                    }, null, 8, ["Name"]),
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Translate('Logo')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_CookiesImageInput, {
                        Res: 'D_Company_Logo',
                        style: {"border-radius":"var(--rad1)","width":"16em","height":"12em"}
                      })
                    ]),
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Translate('FAV ICON')), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_CookiesImageInput, {
                        Res: 'D_Company_FavIcon',
                        Default: '',
                        style: {"border-radius":"var(--rad1)","width":"6em","height":"6em"}
                      })
                    ]),
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.Translate('Contact Information')), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_CookiesTable, {
                        onFieldEdited: _ctx.FieldEdited,
                        onDeleteRow: _ctx.RemoveContact,
                        class: "Shadow1",
                        TableSettings: _ctx.TableSettings,
                        CookiesData: _ctx.CookiesContact,
                        Search: '',
                        Loading: (_ctx.Loading.length > 0),
                        Saving: (_ctx.TableSaving.length > 0),
                        Saved: _ctx.Saved
                      }, null, 8, ["onFieldEdited", "onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "Saved"]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_CookiesIcon, {
                          class: "SQR2em P1em HoverGlow",
                          ToolTip: _ctx.Translate('Add New'),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AddContact())),
                          ID: ('Add' as IconsIDs)
                        }, null, 8, ["ToolTip"])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_17,
              _hoisted_18
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Companies_Edit': 'Companies_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              class: "F-Bold CookiesButton DialogFooterButton BGMain"
            }, _toDisplayString(_ctx.Translate('Save')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}